export const base = 'uploadlogo';

export const getPresignedUrl = `${base}/pre-signed-url`;
export const getMakePublicImage = `${base}/make-public-image`;
export const getUserUrlLogo = `${base}/user-url-logo`;
export const postLogo = `${base}`;
